export default {
    'ACTIVE': "__green",
    'INACTIVE': "__blue",
    'BLOCKED': "__red",
}